// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderOutlinedSvg from "@ant-design/icons-svg/es/asn/FolderOutlined";
import AntdIcon from '../components/AntdIcon';

var FolderOutlined = function FolderOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderOutlinedSvg
  }));
};

FolderOutlined.displayName = 'FolderOutlined';
export default React.forwardRef(FolderOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FolderOutlined.js
// module id = 1201
// module chunks = 0